import React, {Component} from "react"

import {Dialog, DialogTitle, DialogContent, DialogActions, Button} from "@material-ui/core"

import api from "../api.js"

import ErrorMessageDialog from "../ui/ErrorMessageDialog.js"

import ItemsList from "./SelectTemplateDialog/ItemsList.js"

/**
 * onSelectClick(folder_id)
 * onCancelClick
 */

class SelectTemplateDialog extends Component {

    constructor(props) {

        super(props)

        this.ROOT_FOLDER_NAME = "Корневой каталог"

        this.state = {
            dialog: undefined,
            selected: undefined,
            folder_id: 0,
            parent_folder_name: this.ROOT_FOLDER_NAME,
            templates: [],
        }

        this.handle_error = this.handle_error.bind(this)
        this.handle_onSelectClick = this.handle_onSelectClick.bind(this)
        this.update = this.update.bind(this)

    }

    /**
     * Диалог сообщения о ошибке.
     * 
     * @param {string|Error} error - ошибка.
     */

	handle_error(error) {
        let message = error instanceof String ? error : error.message
		this.setState({
			dialog: <ErrorMessageDialog 
				message = {message}
				onClose = {() => {
					this.update()
                        .then(() => this.setState({dialog: undefined}))
                        .catch(this.handle_error)
				}}
			/>
		})
	}    

    async componentDidMount() {
        await this.update()
            .catch(this.handle_error)
    }

    /**
     * Обновление состояния.
     */

    async update() {
        const response = await api.purchases_templates.list(this.state.folder_id)
        this.setState({templates: response})
    }

    /**
     * Обработчик выбора шаблона закупки.
     * 
     * @param {*} template - выбранный шаблон.
     */

    handle_onSelectClick(template) {
        if (typeof this.props.onSelectClick === "function") {
            this.props.onSelectClick(template)
        }
    }

    render() {

        return <Dialog
            open
            fullWidth 
            onClick = {e => {
                e.stopPropagation()
                this.setState({selected: undefined})
            }}
        >
            <DialogTitle>Выбрать шаблон</DialogTitle>
            <DialogContent>
                <ItemsList 
                    items = {this.state.templates}
                    selected = {this.state.selected}
                    folder_id = {this.state.folder_id}
                    onItemClick = {template => this.setState({selected: template})}
                    onItemDoubleClick = {template => {
                        if (template.type === 0) {
                            this.setState({selected: undefined, folder_id: template.id}, async () => await this.update().catch(this.handle_error))
                        } else {
                            this.handle_onSelectClick(template)
                        }
                    }}
                    onBackClick = {folder_id => {
                        api.purchases_templates.get(folder_id)
                            .then(template => {this.setState({folder_id: template.folder_id})})
                            .then(this.update)
                            .catch(this.handle_error)
                    }}
                />                
            </DialogContent>
            <DialogActions>
                <Button
                    disabled = {!(this.state.selected && this.state.selected.type)}
                    onClick = {e => {
                        e.stopPropagation()
                        if (this.state.selected) {
                            this.handle_onSelectClick(this.state.selected)
                        }
                    }}
                >Выбрать</Button>
                <Button
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onCancelClick === "function") {
                            this.props.onCancelClick()
                        }
                    }}
                >Отмена</Button>
            </DialogActions>
        </Dialog>

    }
}

export default SelectTemplateDialog